import { render } from "./product-addon-blue-blocker.vue?vue&type=template&id=8c321536&scoped=true&lang=pug"
import script from "./product-addon-blue-blocker.vue?vue&type=script&lang=js"
export * from "./product-addon-blue-blocker.vue?vue&type=script&lang=js"

import "./product-addon-blue-blocker.vue?vue&type=style&index=0&id=8c321536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c321536"]])

export default __exports__